export default __webpack_public_path__ + "static/media/LinkedIn.31917e8f.svg";